import { mergeStyles } from '../../../internal/utils';
import inputWrapperStyles from '../../../internal/styles/inputWrapperAdornment.module.css';
import mainStyles from './styles.module.css';
export function getInputAdornmentStyles(size) {
  return mergeStyles(mainStyles, inputWrapperStyles, require("./size/".concat(size, ".module.css")));
}